import React from 'react';
import './ClasspepLoader.css';
import { Backdrop } from '@mui/material';

const ClasspepLoader = () => {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(1px)',
        WebkitBackdropFilter: 'blur(1px)',
      }}
      open={true}
    >
      <div className="loader-container">
        <div className="circle-wrapper">
          <div className="center-image">
            <img src="https://academy.classpep.in/logo512.png" alt="loading icon" />
          </div>
          <svg viewBox="0 0 200 200" className="circle-svg">
            <defs>
              <path
                id="circlePath"
                d="M100,100 m-50,0 a50,50 0 1,1 100,0 a50,50 0 1,1 -100,0"
              />
              <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#a700f4" />
                <stop offset="100%" stopColor="#2a47f4" />
              </linearGradient>
            </defs>
            <g className="rotating-text">
              <text fill="url(#textGradient)" fontSize="15" fontWeight="bold" letterSpacing="2.2">
                <textPath href="#circlePath" startOffset="0%">
                  ClassPep • ClassPep • ClassPep •
                </textPath>
              </text>
            </g>
          </svg>
        </div>
      </div>
    </Backdrop >
  );
};

export default ClasspepLoader;
